import React, {useEffect, useState} from "react";
import {Actions} from "../../../client/Actions";
import Tooltip from "../../components/tooltip/Tooltip";

export function AppInfo({fixed = true}) {
    const [apiInfo, setApInfo] = useState();


    function loadApiInfo() {
        Actions.get("actuator/info", setApInfo, () => {
        })
    }


    useEffect(() => {
        loadApiInfo();
    }, []);


    return <Tooltip
        tooltip={<div>
            <p>{`Technical info: ${process.env.REACT_APP_TECHNICAL_VERSION}`}</p>
            <p>{`API: ${apiInfo?.app?.version} `}</p>
            <p>{`API Build: ${apiInfo?.app?.build}`}</p>
        </div>

        }>
        <p className={fixed ? "version" : ""}>{process.env.REACT_APP_VERSION}</p>
    </Tooltip>;
}